<template>
  <div class="c-app flex-row align-items-center">
    <div class="m-0">
      <div class="container-boxs center">
        <div class="text-left">
          <div class="card-custom-web" style="height: auto">
            <br />
            <div class="text-left ml-3">
              <CRow>
                <div style="width: 60%"></div>
                <div style="width: 40%">
                  <!-- <Countdown :date="end" @onFinish="finish()"></Countdown> -->
                </div>
              </CRow>
              <!-- <CCard>
      <br /><br /><br /><br />
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <h5
                class="text-left mt-5 d-flex d-sm-none text-black bold"
                style="font-size: 18px"
              >
                Question 1.
                Farid has been _____ his parent to buy him a new bike for months.
              </h5>
              
              <p style="margin-bottom: 0px" v-if="choiceA != ''">
                A. {{choiceA}} 
              </p>
              <p style="margin-bottom: 0px" v-if="choiceB != ''">
                B. {{choiceB}} 
              </p>
              <p style="margin-bottom: 0px" v-if="choiceC != ''">
                C. {{choiceC}} 
              </p>
              <p style="margin-bottom: 0px" v-if="choiceD != ''">
                D. {{choiceD}} 
              </p>
              <p style="margin-bottom: 0px" v-if="choiceE != ''">
                E. {{choiceE}}
              </p>
              <p style="margin-bottom: 0px" v-if="choiceF != ''">
                F. {{choiceF}}
              </p>
              <p style="margin-bottom: 0px" v-if="choiceG != ''">
                G. {{choiceG}}
              </p>
              
              <CRow>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-4 mt-1"
                >
                  <div class="text-center custom-width-lg">
                    <CRow class="justify-content-center">
                      <CCol sm="12" lg="12" class="mt-4" style="display: flex">
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceA != ''">
                          <form>
                            <CBadge
                              shape="pill"
                              color="danger"
                              class="custom-pill box-shadow"
                            >
                              <input type="radio" v-model="answer" value="1" />
                              <span
                                style="text-align: center; width: 90%"
                                class="custom-label"
                                >A
                              </span>
                            </CBadge>
                          </form>
                        </span>
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceB != ''">
                          <CBadge
                            shape="pill"
                            color="success"
                            class="custom-pill box-shadow"
                          >
                            <input
                              type="radio"
                              v-model="answer"
                              value="2"
                            /><span
                              style="text-align: center; width: 90%"
                              class="custom-label"
                            >
                              B
                            </span>
                          </CBadge>
                        </span>
                        <br />
                      </CCol>
                      <CCol sm="12" lg="12" class="mt-4" style="display: flex">
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceC != ''">
                          <CBadge
                            shape="pill"
                            color="danger"
                            class="custom-pill box-shadow"
                          >
                            <input
                              type="radio"
                              v-model="answer"
                              value="3"
                            /><span
                              style="text-align: center; width: 90%"
                              class="custom-label"
                            >
                              C
                            </span>
                          </CBadge>
                        </span>
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceD != ''">
                          <CBadge
                            shape="pill"
                            color="danger"
                            class="custom-pill box-shadow"
                          >
                            <input
                              type="radio"
                              v-model="answer"
                              value="4"
                            /><span
                              style="text-align: center; width: 90%"
                              class="custom-label"
                            >
                              D
                            </span>
                          </CBadge>
                        </span>
                      </CCol>
                      <CCol sm="12" lg="12" class="mt-4" style="display: flex" v-if="choiceE != ''">
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceE != ''">
                          <form>
                            <CBadge
                              shape="pill"
                              color="danger"
                              class="custom-pill box-shadow"
                            >
                              <input type="radio" v-model="answer" value="1" />
                              <span
                                style="text-align: center; width: 90%"
                                class="custom-label"
                                >E
                              </span>
                            </CBadge>
                          </form>
                        </span>
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceF != ''">
                          <CBadge
                            shape="pill"
                            color="danger"
                            class="custom-pill box-shadow"
                          >
                            <input
                              type="radio"
                              v-model="answer"
                              value="2"
                            /><span
                              style="text-align: center; width: 90%"
                              class="custom-label"
                            >
                              F
                            </span>
                          </CBadge>
                        </span>
                        <br />
                      </CCol>
                      <CCol sm="6" lg="6" class="mt-4" style="display: flex" v-if="choiceG != ''">
                        <span sm="6" lg="6" style="flex: 2">
                          <form>
                            <CBadge
                              shape="pill"
                              color="danger"
                              class="custom-pill box-shadow"
                            >
                              <input type="radio" v-model="answer" value="1" />
                              <span
                                style="text-align: center; width: 90%"
                                class="custom-label"
                                >G
                              </span>
                            </CBadge>
                          </form>
                        </span>
                        
                        <br />
                      </CCol>

                      <CCol sm="12" class="text-left mt-5">
                        <div><h3>Explanation</h3></div>
                        <br />

                        <div><h4>Answer : B</h4></div>
                        <p>
                          It is sufficient to come up with onw counterexample to
                          show the statement/implication is false. This
                          statement is false since 2 is even and 2 is a prime
                          number.
                        </p>
                      </CCol>

                      <CCol sm="12" class="text-right">
                        <CButton
                          color="primary"
                          class="mt-4 mb-4 float-right"
                          size="lg"
                          @click="SubmitAnswer"
                          >Next
                          <div>
                            <CIcon name="cil-arrow-right" />
                          </div>
                        </CButton>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard> -->

              <CCard
                class="p-1 mt-5"
                v-for="(item, index) in AnswerList"
                v-bind:key="item.quizId"
              >
                <div class="ml-3 mr-3 mt-3 mb-2">
                  <h5 class="text-left text-black bold d-flex display-6">
                    Question
                    <span v-html="item.questionNum" class="ml-2"></span>
                    <br />
                  </h5>
                  <span v-html="item.question" style="max-width: 100%"></span>
                  <div
                    class="col-12 text-center"
                    v-if="item.questionImagePath != null"
                  >
                    <div style="float: right" class="mb-2">
                      <CButton color="info" type="submit">
                        <i class="fa icon-printer"></i> Download Image
                      </CButton>
                    </div>
                    <br />
                    <div style="clear: both"></div>
                    <CRow class="justify-content-center">
                      <CCard
                        style="
                          background: #ffffff;
                          border: #000000;
                          width: 100%;
                        "
                        class="box-shadow"
                        @click="FullImage()"
                      >
                        <div id="printsection">
                          <img
                            style="max-width: 100%; height: 200px"
                            class="image"
                            :src="getPic(item)"
                          />
                        </div>
                      </CCard>
                    </CRow>
                  </div>

                  <!-- <CRow>
                      <div
                        class="
                          col-12
                          mt-1"
                        v-for="(ans, indexanswer) in item.answer"
                        v-bind:key="indexanswer">
                        <div class="text-center custom-width-lg">
                          <CRow class="justify-content-center">
                         <CCol sm="12" lg="12" class="mt-4">
                          <span sm="12" lg="12">
                            <form>
                              
                              <label style="border:2px solid #eee;height:60px;width:100%;text-align:left;border-radius:5px;background:green" class="custom-bg-focus" v-if="item.choiceA === true">
                                <input
                                  type="radio"
                                  name="radio"
                                  v-model="chosen[index]"
                                  :id="ans.Id"
                                        :value="{ id: ans.QuestionId, name: ans.Answers, value: ans.Value }"
                                  class="radio-custom"
                                />
                                <span class="p-0" style="margin-left: 20px;margin-top: 10px;">A. {{ ans.Answers }}</span>
                              </label>
  
                              <label style="border:2px solid #eee;height:60px;width:100%;text-align:left;border-radius:5px;background:green" class="custom-bg-focus" v-if="item.choiceB === true">
                                <input
                                  type="radio"
                                  name="radio"
                                  v-model="chosen[index]"
                                  class="radio-custom"
                                  :id="ans.Id"
                                  :value="{ id: ans.QuestionId, name: ans.Answers, value: ans.Value }"
                                />
                                <span class="p-0" style="margin-left: 20px;margin-top: 10px;">B. {{ ans.Answers }}</span>
                              </label>
                            </form>
                          </span>
                        </CCol>
  
                        <CCol sm="12" lg="12">
                          <span sm="12" lg="12">
                            <form>
                              <label style="border:2px solid #eee;height:60px;width:100%;text-align:left;border-radius:5px;background:green" class="custom-bg-focus" v-if="item.choiceC === true">
                                <input
                                  type="radio"
                                  name="radio"
                                  v-model="chosen[index]"
                                  class="radio-custom"
                                  :id="ans.Id"
                                  :value="{ id: ans.QuestionId, name: ans.Answers, value: ans.Value }"
                                />
                                <span class="p-0" style="margin-left: 20px;margin-top: 10px;">C. {{ ans.Answers }}</span>
                              </label>
  
                              <label style="border:2px solid #eee;height:60px;width:100%;text-align:left;border-radius:5px;background:green" class="custom-bg-focus" v-if="item.choiceD === true">
                                <input
                                  type="radio"
                                  name="radio"
                                  v-model="chosen[index]"
                                  class="radio-custom"
                                  :id="ans.Id"
                                  :value="{ id: ans.QuestionId, name: ans.Answers, value: ans.Value }"
                                />
                                <span class="p-0" style="margin-left: 20px;margin-top: 10px;">D. {{ ans.Answers }}</span>
                              </label>
                            </form>
                          </span>
                        </CCol>
  
                          
                          </CRow>
                        </div>
  
  
                       
  
                       
                      </div>
                     
                    </CRow> -->

                  <!-- <span class="columns">
                    <span class="column"></span>
                    <CRow>
                      <div
                        class="
                          col-12
                          mt-1
                        "
                        v-for="(ans, indexanswer) in item.answer"
                        v-bind:key="indexanswer"
                      
                      >
                        <div class="text-center custom-width-lg">
                          <CRow class="justify-content-center">
                         <CCol sm="12" lg="12" class="mt-4">
                          <span sm="12" lg="12">
                            <form>
                              
                              <label style="border:2px solid #eee;height:60px;width:100%;text-align:left;border-radius:5px;background: green;" class="custom-bg-focus" v-if="ans.Value===1 && ans.choiceA === true">
                                <input
                                  type="radio"
                                  name="radio"
                                  v-model="chosen[index]"
                                  :id="ans.Id"
                                        :value="{ id: ans.QuestionId, name: ans.Answers, value: ans.Value }"
                                  class="radio-custom"
                                />
                                <span class="p-0" style="margin-left: 20px;margin-top: 10px;">A. {{ ans.Answers }}</span>
                              </label>
  
                              <label style="border:2px solid #eee;height:60px;width:100%;text-align:left;border-radius:5px;background: green;" class="custom-bg-focus" v-if="ans.Value===2 && ans.choiceB === true">
                                <input
                                  type="radio"
                                  name="radio"
                                  v-model="chosen[index]"
                                  class="radio-custom"
                                  :id="ans.Id"
                                  :value="{ id: ans.QuestionId, name: ans.Answers, value: ans.Value }"
                                />
                                <span class="p-0" style="margin-left: 20px;margin-top: 10px;">B. {{ ans.Answers }}</span>
                              </label>
                            </form>
                          </span>
                        </CCol>
  
                        <CCol sm="12" lg="12">
                          <span sm="12" lg="12">
                            <form>
                              <label style="border:2px solid #eee;height:60px;width:100%;text-align:left;border-radius:5px;background: green;" class="custom-bg-focus" v-if="ans.Value===3 && ans.choiceC === true">
                                <input
                                  type="radio"
                                  name="radio"
                                  v-model="chosen[index]"
                                  class="radio-custom"
                                  :id="ans.Id"
                                  :value="{ id: ans.QuestionId, name: ans.Answers, value: ans.Value }"
                                />
                                <span class="p-0" style="margin-left: 20px;margin-top: 10px;">C. {{ ans.Answers }}</span>
                              </label>
  
                              <label style="border:2px solid #eee;height:60px;width:100%;text-align:left;border-radius:5px;background: green;" class="custom-bg-focus" v-if="ans.Value===4 && ans.choiceD === true">
                                <input
                                  type="radio"
                                  name="radio"
                                  v-model="chosen[index]"
                                  class="radio-custom"
                                  :id="ans.Id"
                                  :value="{ id: ans.QuestionId, name: ans.Answers, value: ans.Value }"
                                />
                                <span class="p-0" style="margin-left: 20px;margin-top: 10px;">D. {{ ans.Answers }}</span>
                              </label>
                            </form>
                          </span>
                        </CCol>
  
                          
                          </CRow>
                        </div>
  
  
                       
  
                       
                      </div>
                     
                    </CRow>
                    </span> -->

                  <span class="columns">
                    <span class="column"></span>
                    <CRow>
                      <div
                        class="col-12 mt-1"
                        v-for="(ans, indexanswer) in item.answer"
                        v-bind:key="indexanswer"
                      >
                        <div class="text-center custom-width-lg">
                          <CRow class="justify-content-center">
                            <CCol sm="12" lg="12" class="mt-4">
                              <span sm="12" lg="12">
                                <form>
                                  <label
                                  v-bind:style="{
                                      backgroundColor: ans.choiceA
                                        ? '#E8F4FF'
                                        : 'transparent',
                                      color: ans.choiceA
                                        ? '#007CEF'
                                        : 'inherit',
                                      border: ans.choiceA
                                        ? '0px'
                                        : '2px solid #eee',
                                      height: ans.choiceA ? '60px' : '60px',
                                      width: ans.choiceA ? '100%' : '100%',
                                      'text-align': ans.choiceA
                                        ? 'left'
                                        : 'left',
                                      'border-radius': ans.choiceA
                                        ? '5px'
                                        : '5px',
                                    }"
                                    class="custom-bg-focus"
                                    v-if="ans.Value === 1"
                                  >
                                    <input
                                      type="radio"
                                      name="radio"
                                      v-model="chosen[index]"
                                      :id="ans.Id"
                                      :value="{
                                        id: ans.QuestionId,
                                        name: ans.Answers,
                                        value: ans.Value,
                                      }"
                                      class="radio-custom"
                                    />
                                    <span
                                      class="p-0"
                                      style="
                                        margin-left: 20px;
                                        margin-top: 10px;
                                      "
                                      >A. {{ ans.Answers }}</span
                                    >
                                  </label>

                                  <label
                                    v-bind:style="{
                                      backgroundColor: ans.choiceB
                                        ? '#E8F4FF'
                                        : 'transparent',
                                      color: ans.choiceB
                                        ? '#007CEF'
                                        : 'inherit',
                                      border: ans.choiceB
                                        ? '0px'
                                        : '2px solid #eee',
                                      height: ans.choiceB ? '60px' : '60px',
                                      width: ans.choiceB ? '100%' : '100%',
                                      'text-align': ans.choiceB
                                        ? 'left'
                                        : 'left',
                                      'border-radius': ans.choiceB
                                        ? '5px'
                                        : '5px',
                                    }"
                                    class="custom-bg-focus"
                                    v-if="ans.Value === 2"
                                  >
                                    <input
                                      type="radio"
                                      name="radio"
                                      v-model="chosen[index]"
                                      class="radio-custom"
                                      :id="ans.Id"
                                      :value="{
                                        id: ans.QuestionId,
                                        name: ans.Answers,
                                        value: ans.Value,
                                      }"
                                    />
                                    <span
                                      class="p-0"
                                      style="
                                        margin-left: 20px;
                                        margin-top: 10px;
                                      "
                                      >B. {{ ans.Answers }}</span
                                    >
                                  </label>
                                </form>

                                <form>
                                  <label
                                    v-bind:style="{
                                      backgroundColor: ans.choiceC
                                      ? '#E8F4FF'
                                        : 'transparent',
                                      color: ans.choiceC
                                        ? '#007CEF'
                                        : 'inherit',
                                      border: ans.choiceC
                                        ? '0px'
                                        : '2px solid #eee',
                                      height: ans.choiceC ? '60px' : '60px',
                                      width: ans.choiceC ? '100%' : '100%',
                                      'text-align': ans.choiceC
                                        ? 'left'
                                        : 'left',
                                      'border-radius': ans.choiceC
                                        ? '5px'
                                        : '5px',
                                    }"
                                    class="custom-bg-focus"
                                    v-if="ans.Value === 3"
                                  >
                                    <input
                                      type="radio"
                                      name="radio"
                                      v-model="chosen[index]"
                                      :id="ans.Id"
                                      :value="{
                                        id: ans.QuestionId,
                                        name: ans.Answers,
                                        value: ans.Value,
                                      }"
                                      class="radio-custom"
                                    />
                                    <span
                                      class="p-0"
                                      style="
                                        margin-left: 20px;
                                        margin-top: 10px;
                                      "
                                      >C. {{ ans.Answers }}</span
                                    >
                                  </label>

                                  <label
                                    v-bind:style="{
                                      backgroundColor: ans.choiceD
                                        ? '0px'
                                        : 'transparent',
                                      color: ans.choiceD
                                        ? '#007CEF'
                                        : 'inherit',
                                      border: ans.choiceD
                                        ? '2px solid #eee'
                                        : '2px solid #eee',
                                      height: ans.choiceD ? '60px' : '60px',
                                      width: ans.choiceD ? '100%' : '100%',
                                      'text-align': ans.choiceD
                                        ? 'left'
                                        : 'left',
                                      'border-radius': ans.choiceD
                                        ? '5px'
                                        : '5px',
                                    }"
                                    class="custom-bg-focus"
                                    v-if="ans.Value === 4"
                                  >
                                    <input
                                      type="radio"
                                      name="radio"
                                      v-model="chosen[index]"
                                      class="radio-custom"
                                      :id="ans.Id"
                                      :value="{
                                        id: ans.QuestionId,
                                        name: ans.Answers,
                                        value: ans.Value,
                                      }"
                                    />
                                    <span
                                      class="p-0"
                                      style="
                                        margin-left: 20px;
                                        margin-top: 10px;
                                      "
                                      >D. {{ ans.Answers }}</span
                                    >
                                  </label>
                                </form>
                              </span>
                            </CCol>
                          </CRow>
                        </div>
                      </div>
                    </CRow>
                  </span>

                  <CCol sm="12">
                    <strong>Answer:</strong>

                    <div v-if="item.choiceA === true">
                      <div
                        class="col-12 mt-1"
                        v-for="(ans, indexanswer) in item.answer.filter(
                          (a) => a.choiceA === true
                        )"
                        v-bind:key="indexanswer"
                      >
                        <!-- <img
                          :src="
                            item.choiceA === ans.choiceA
                              ? 'assets/img/icon/correct.svg'
                              : '../../assets/img/icon/incorrect.svg'
                          "
                        /> -->

                     </div>
                      Choice A: {{ item.choiceAnswer }}
                    </div>

                    <div v-if="item.choiceB === true">
                      <div
                        class="col-12 mt-1"
                        v-for="(ans, indexanswer) in item.answer.filter(
                          (a) => a.choiceB === true
                        )"
                        v-bind:key="indexanswer"
                      >
                        <!-- <img
                          :src="
                            item.choiceB === ans.choiceB
                              ? 'assets/img/icon/correct.svg'
                              : '../../assets/img/icon/incorrect.svg'
                          "
                        /> -->
                      
                      </div>
                      Choice B : {{ item.choiceAnswer }}
                    </div>
                    <div v-if="item.choiceC === true">
                      <div
                        class="col-12 mt-1"
                        v-for="(ans, indexanswer) in item.answer.filter(
                          (a) => a.choiceC === true
                        )"
                        v-bind:key="indexanswer"
                      >
                        <!-- <img
                          :src="
                            item.choiceC === ans.choiceC
                              ? 'assets/img/icon/correct.svg'
                              : '../../assets/img/icon/incorrect.svg'
                          "
                        /> -->
                       
                      </div>
                      Choice C : {{ item.choiceAnswer }}
                    </div>
                    <div v-if="item.choiceD === true">
                      <div
                        class="col-12 mt-1"
                        v-for="(ans, indexanswer) in item.answer.filter(
                          (a) => a.choiceD === true
                        )"
                        v-bind:key="indexanswer"
                      >
                        <!-- <img
                          :src="
                            item.choiceD === ans.choiceD
                              ? 'assets/img/icon/correct.svg'
                              : '../../assets/img/icon/incorrect.svg'
                          "
                        /> -->
                       
                      </div>
                      Choice D: {{ item.choiceAnswer }}
                    </div>
                  </CCol>
                </div>
              </CCard>
            </div>
            <!-- <div class="bottom-centers">
                <CButton
                  color="primary"
                  size="lg"
                  @click="SubmitAnswer"
                  class="btn-select-blue"
                  >Next
                </CButton>
              </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="header-top">
      <div class="m-0 custom-header-quiz-title"></div>
    </div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div class="header-right">
      <span @click="GoHomePage()"><CIcon name="cil-home" /></span>
      <br />
    </div>
    <div style="clear: both"></div>
  </div>
</template>
 
 <script>
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import _ from "lodash";
import Countdown from "../../containers/Countdown.vue";

Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import PinchZoom from "vue-pinch-zoom";

Vue.component("pinch-zoom", PinchZoom);
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../assets/css/pagebreak.css",
  ],
};
Vue.use(VueHtmlToPaper, options);

export default {
  name: "Login",
  components: {
    PulseLoader,
    Countdown,
  },
  data() {
    return {
      AnswerList: [],
      qSummary: {},
      SubmittedForm: false,
      Error: false,
      hasScrolledToBottom: false,
      ViewImageModal: false,
      //isDisabled: "",
      //answer: "",
      chosen: [],
      end: this.$route.query.endTime,
      Submitted: false,
    };
  },
  async mounted() {
    this.GetQuesDetails();
    this.GetQuizPreview();
    this.GetInfoUser();
  },
  computed: {},
  methods: {
    GoHomePage() {
      this.$router.push("/ExistingUser");
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
          }
        });
    },
    //Get details question
    async GetQuesDetails() {
      return this.$API
        .get(
          this.$ListQuestionAllAnswerPreview +
            "?quizId=" +
            this.$route.query.quizId +
            "&startId=" +
            this.$route.query.startId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.AnswerList = response.data;
            console.log("AnswerList", this.AnswerList);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //Get quiz summary
    async GetQuizPreview() {
      this.$API
        .get(this.$QuizPreview + "?quizId=" + this.$route.query.quizId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
            console.log(this.qSummary);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

    //Page Quiz List
    GoToPageQuizList() {
      this.$router.push(
        "/QuizTeacherQuizList?userId=" +
          this.qSummary.userId +
          "&subjectId=" +
          this.qSummary.SubjectId
      );
    },
    //Edit Question
    GoToPageEditQuiz(questionId) {
      this.$router.push(
        "/QuizTeacherEditQuestion?questionId=" +
          questionId +
          "&quizId=" +
          this.$route.query.quizId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    //Add Question
    GoToPageCreateQuestion(quizTitleId) {
      this.$router.push(
        "/QuizTeacherCreateQuestion?quizTitleId=" +
          this.$route.query.quizId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    //publish Quiz
    PublishQuiz() {
      // if (this.Question !== "") {
      //   this.CreateQuestion();
      // }
      const formData = new FormData();
      formData.append("quizId", this.$route.query.quizId);
      console.log("try");

      return this.$API
        .post(this.$PublishQuiz, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.GoToPageQuizList();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
            console.log(error.response.data);
          }
        });
    },

    //Image
    ViewFullImage(questionFolderName, questionImageName) {
      this.getPicFull(questionFolderName, questionImageName);
      console.log("testing" + questionFolderName + questionImageName);

      this.ViewImageModal = true;

      this.foldername = questionFolderName;
      this.imagename = questionImageName;

      this.getPicFull(this.foldername);
    },
    getPic(AnswerList) {
      return (
        "https://pickiddo.com/Quiz/" +
        AnswerList.questionFolderName +
        "/" +
        AnswerList.questionImageName
      );
    },

    getPicFull() {
      console.log("testing1" + this.foldername + this.imagename);
      return (
        "https://pickiddo.com/Quiz/" + this.foldername + "/" + this.imagename
      );
    },
    async SubmitAnswer() {
      this.Submitted = true;
      const formData = new FormData();
      var combinedrates = [];
      for (let i in this.chosen) {
        let item = this.chosen[i];

        console.log(i + "testing");
        console.log(item.value + "console");
        console.log(item.id + "question");

        combinedrates.push({
          QuizTitleId: this.$route.query.quizId,
          StudentId: this.$route.query.studentId,
          QuizStartId: this.$route.query.startId,
          QuizQuestionId: item.id,
          Choice: item.value,
          Answer: item.name,
        });
      }

      let feedData = JSON.stringify(combinedrates);

      if (combinedrates.length < this.AnswerList.length) {
        this.$dialog.alert("Please complete all quiz").then(function (dialog) {
          //console.log("Closed");
        });
      } else {
        formData.append("ansJson", feedData);
        console.log("lengt" + combinedrates.length);

        return this.$API
          .post(this.$StudentSubmitAnswerAll, formData, {
            withCredentials: true,
          })
          .then((response) => {
            console.log(response.status);
            console.log(response.data);
            if (response.status == 200) {
              // var startId = response.data;
              // this.GoToRefresh();
              this.GoToPageScore();
              console.log("Ok");
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.data);
            }
          });
      }
    },
    GoToRefresh() {
      window.location.reload();
    },
    GoToPageScore() {
      this.$router.push(
        "/Class/QuizFinalScore?studentId=" +
          this.$route.query.studentId +
          "&quizId=" +
          this.$route.query.quizId +
          "&startId=" +
          this.$route.query.startId +
          "&userId=" +
          this.user.id
      );
    },
    async SubmitAnswerWoPopup(questionId) {
      const formData = new FormData();
      var combinedrates = [];
      for (let i in this.chosen) {
        let item = this.chosen[i];

        console.log(i + "testing");
        console.log(item.value + "console");
        console.log(item.id + "question");

        combinedrates.push({
          QuizTitleId: this.$route.query.quizId,
          StudentId: this.$route.query.studentId,
          QuizStartId: this.$route.query.startId,
          QuizQuestionId: item.id,
          Choice: item.value,
          Answer: item.name,
        });
      }

      let feedData = JSON.stringify(combinedrates);

      formData.append("ansJson", feedData);
      console.log("lengt" + combinedrates.length);

      return this.$API
        .post(this.$StudentSubmitAnswerAll, formData, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.status);
          console.log(response.data);
          if (response.status == 200 && response.data != null) {
            // var startId = response.data;
            // this.GoToRefresh();
            this.GoToPageScore();
            console.log("Ok");
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.data);
          }
        });
    },
    finish() {
      this.SubmitAnswerWoPopup();
      this.GoToPageScore();
    },
    async SubmitAnswerWoPopup(questionId) {
      const formData = new FormData();
      var combinedrates = [];
      for (let i in this.chosen) {
        let item = this.chosen[i];

        console.log(i + "testing");
        console.log(item.value + "console");
        console.log(item.id + "question");

        combinedrates.push({
          QuizTitleId: this.$route.query.quizId,
          StudentId: this.$route.query.studentId,
          QuizStartId: this.$route.query.startId,
          QuizQuestionId: item.id,
          Choice: item.value,
          Answer: item.name,
        });
      }

      let feedData = JSON.stringify(combinedrates);

      formData.append("ansJson", feedData);
      console.log("lengt" + combinedrates.length);

      return this.$API
        .post(this.$StudentSubmitAnswerAll, formData, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.status);
          console.log(response.data);
          if (response.status == 200 && response.data != null) {
            // var startId = response.data;
            // this.GoToRefresh();
            this.GoToPageScore();
            console.log("Ok");
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.data);
          }
        });
    },
  },
};
</script>
 
 <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

.imageFull {
  object-fit: fill;
  object-position: center;
  font-family: "object-fit: fill; object-position: center;";
}
/* input[type="radio"] {
   opacity: 0;
 } */
p img {
  width: 100% !important;
}

input[type="radio"] + label {
  color: black;
}

.custom-bg-focus:hover {
  background-color: #007cef;
  color: #fff;
}

.bg-custom-primary {
  background-color: #007cef;
  color: #fff;
}

.custom-bg-focus input:checked + span {
  background-color: #007cef;
  min-height: 60px;
  border-radius: 5px;
  left: -20px;
  top: -10px;
  position: relative;
  width: 100% !important;
  color: #fff;
}

.custom-bg-focus input {
  position: absolute;
  left: -9999px;
}
.custom-bg-focus span {
  display: flex;
  align-items: center;
  transition: 0.25s ease;
}
.custom-bg-focus span:after {
  display: flex;
  flex-shrink: 0;
  background-color: #007cef;
}

.custom-bg-focus span {
  display: flex;
  align-items: center;
  transition: 0.25s ease;
}

label span:hover {
  background-color: #007cef;
  color: #fff;
}

label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  /* background-color: #fff; */
  margin-left: 20px;
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
</style>